import React from 'react';
import { FormattedMessage } from '@nykaa/intl-shared';
import { styled } from '@nykaa/ui-components';

interface ItemProps {
  itemClass: string;
  customLinkClass?: string;
  link: string;
  text: string;
  tag?: string;
}

const Tag = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => theme.spacing.spacing60}
    ${({ theme }) => theme.spacing.spacing0};
  padding: ${({ theme }) => theme.spacing.spacing20}
    ${({ theme }) => theme.spacing.spacing40};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.surface};
  margin-right: ${({ theme }) => theme.spacing.spacing100};
  margin-left: -${({ theme }) => theme.spacing.spacing60};
  ${({ theme }) => theme.typography.labelSmall};
`;

function Item({ itemClass, customLinkClass = '', link, text, tag }: ItemProps) {
  return (
    <li className={itemClass}>
      <a
        href={link}
        className={`link ${customLinkClass}`}
      >
        <FormattedMessage
          id={text}
          defaultMessage={text}
        />
      </a>
      {tag && <Tag>{tag}</Tag>}
    </li>
  );
}

export default Item;
